import { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const REASONS = [
  { num: '01', title: 'End-to-End Ownership',      desc: "We don't just code — we think strategically. From concept to deployment, we own every step of your digital journey." },
  { num: '02', title: 'Subscription = Peace of Mind', desc: 'No surprise invoices. One flat monthly fee covers everything — dev, SEO, AI, social, and growth strategy.' },
  { num: '03', title: 'Built for Small Businesses', desc: 'We understand the hustle. Our solutions are practical, affordable, and results-driven — no corporate bloat.' },
  { num: '04', title: 'Modern Tech, Real Results',  desc: 'We leverage cutting-edge AI, automation, and analytics — not because it\'s trendy, but because it works.' },
];

export default function WhyUs() {
  const ref = useRef(null);

  useEffect(() => {
    gsap.from(ref.current.querySelector('.why-left'), {
      opacity: 0, x: -40, duration: 0.8, ease: 'power3.out',
      immediateRender: false,
      scrollTrigger: { trigger: ref.current, start: 'top 72%' },
    });
    gsap.from(ref.current.querySelectorAll('.reason-item'), {
      opacity: 0, x: 30, stagger: 0.12, duration: 0.7, ease: 'power3.out',
      immediateRender: false,
      scrollTrigger: { trigger: ref.current, start: 'top 68%' },
    });

    // Ensures ScrollTrigger calculates correct positions after mount.
    ScrollTrigger.refresh();
  }, []);

  return (
    <section id="why-us" ref={ref} className="section section-alt">
      <div className="why-grid">
        <div className="why-left" style={{ flex: '1 1 360px' }}>
          <p className="eyebrow">Why KalakarTechCrew</p>
          <h2 className="heading">
            We're not just
            <br />
            a vendor.
            <br />
            <span className="gradient-text">We're your team.</span>
          </h2>
          <p className="subtitle">
            Most agencies over-promise and under-deliver. We do the opposite.
            We've built systems for garages, traders, and startups — and we
            treat every client like they're our only client.
          </p>
        </div>

        <div style={{ flex: '1 1 360px', display: 'flex', flexDirection: 'column', gap: 14 }}>
          {REASONS.map((r) => (
            <div key={r.num} className="card reason-item">
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: 18 }}>
                <div className="services-icon">{r.num}</div>
                <div>
                  <h4 style={{ fontFamily: 'var(--font-display)', fontWeight: 800 }}>
                    {r.title}
                  </h4>
                  <p className="subtitle" style={{ marginTop: 6 }}>
                    {r.desc}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
